<template>
<div class="go-center">
  <ul v-if="jobs !== -1 && jobs !== -2 && jobs.length !== 0" class="jobs-list">
    <li v-for="job in jobs" v-link="{ path: 'jobs/'+job.id }" class="jobs-list-item">
      <p class="item-text">
        {{ job.title }}
      </p>
    </li>
  </ul>
  <h2 v-if="jobs.length === 0" style="margin:0 2.5em">
    No Jobs available at the moment
  </h2>
  <h2 v-if="jobs === -1" style="margin:0 2.5em">
    Loading ...
  </h2>
  <h2 v-if="jobs === -2" style="margin:0 2.5em">
    Error loading jobs ... Please come back later
  </h2>
</div>
</template>

<style lang="sass">
  @import "../assets/scss/colors"
  @import "../assets/scss/variables"

  .go-center
    margin: 0 auto;
    width: 800px;

  .jobs-list
    display: flex
    flex-direction: row
    flex-wrap: wrap
    height: 15em
    align-self: center
    justify-content: left
    padding: 0
    margin: -1em 0 0 0
    flex: 1 0 auto
    max-width: 800px;

    .jobs-list-item
      width: 10em
      height: 10em
      list-style: none
      margin-right: 2em
      position: relative
      display: inline-flex
      cursor: pointer
      margin-top: 1em

      &:last-child
        margin-right: 0

      &:before
        content: ""
        display: block
        width: 100%
        height: 0
        padding-bottom: 100%
        border-radius: 50%
        transition: background 0.5s ease
        position: absolute
        z-index: -1
        background: rgba($black, 0.9)

      .item-text
        cursor: pointer
        color: $text-light-primary
        text-transform: uppercase
        align-self: center
        margin: 0 0.5em !important
        width: 100%
        text-align: center

  @media screen and (max-width: map_get($grid-breakpoints, "md"))
    .go-center
      width: auto;

    .jobs-list
      flex-direction: column
      align-items: center
      flex: 1 0 auto
      height: auto
      width: auto;

      .jobs-list-item
        margin-right: 0
        margin-bottom: 1em


</style>

<script>
  export default{
    data() {
      return {
        jobs: -1,
        api: false
      }
    },
    ready() {
      this.$http.get('jobs').then((response) => {
        this.$set('jobs', response.data.data)
      }, (response) => {
        console.log("API ERROR", response)
        this.$set('jobs', -2)
      });
    }
  }

</script>



// WEBPACK FOOTER //
// jobs.vue?10a61ba6